import './LegalPage.css';

export default function PrivacyPage() {
  return (
    <div className="lp-page">

      <header className="lp-header">
        <div className="lp-inner">
          <h1 className="lp-header__h1">Privacy Policy</h1>
          <p className="lp-header__meta">Essential Management Ltd · propertytraining.ai</p>
        </div>
      </header>

      <main className="lp-body">
        <div className="lp-inner">

          <section className="lp-section">
            <h2 className="lp-section__heading">1. Who we are</h2>
            <p className="lp-section__body">
              PropertyTraining.ai is operated by Essential Management Ltd. Our registered
              address is 3rd Floor, 207 Regent St, London, W1B 3HH. In this policy,
              "we", "us" and "our" refer to Essential Management Ltd. We are the data
              controller for the personal information we collect through propertytraining.ai.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">2. What information we collect</h2>
            <p className="lp-section__body">We collect:</p>
            <ul className="lp-list">
              <li>Information you give us when you register for an account or buy the course, including your name and email address.</li>
              <li>Payment information processed by Stripe — we do not store full card details on our servers.</li>
              <li>Usage information about how you interact with the course, including lessons viewed and progress.</li>
              <li>Questions you ask the Ask Amanda AI tutor, which are processed by the Anthropic Claude API.</li>
              <li>Basic technical data such as IP address, browser type and device, collected for security and analytics.</li>
            </ul>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">3. How we use your information</h2>
            <p className="lp-section__body">
              We use your information to: deliver the course you've bought, manage your
              account, process payments and refunds, respond to support enquiries, improve
              the platform, send you transactional emails about your purchase, and — only
              with your consent — send occasional updates about new lessons or courses.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">4. Lawful basis</h2>
            <p className="lp-section__body">We process your personal data on the basis of:</p>
            <ul className="lp-list">
              <li><strong>Contract</strong> — to deliver the course you've bought.</li>
              <li><strong>Legitimate interests</strong> — to operate and secure the platform.</li>
              <li><strong>Legal obligation</strong> — for accounting and tax records.</li>
              <li><strong>Consent</strong> — for marketing emails, where you have opted in.</li>
            </ul>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">5. Who we share your information with</h2>
            <p className="lp-section__body">
              We share data with the following processors, only to the extent needed to
              deliver the service: Stripe (payment processing), Anthropic (the Ask Amanda
              AI tutor), VdoCipher (video delivery), our email provider, and our hosting
              provider. We do not sell your data to anyone, and we do not share it for
              advertising.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">6. International transfers</h2>
            <p className="lp-section__body">
              Some of our processors are based outside the UK. Where data is transferred
              internationally, we rely on the UK's adequacy decisions or on Standard
              Contractual Clauses to protect your data.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">7. How long we keep your information</h2>
            <p className="lp-section__body">
              We keep your account and course-progress data for as long as your account
              is active, and for up to seven years afterwards to meet UK accounting and
              tax requirements. You can request deletion at any time.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">8. Your rights</h2>
            <p className="lp-section__body">
              Under UK GDPR you have the right to: access the personal data we hold about
              you; ask us to correct it; ask us to delete it; restrict or object to processing;
              and request portability. To exercise any of these rights, email us at{' '}
              <a href="mailto:amanda@PropertyTraining.ai" className="lp-link">
                amanda@PropertyTraining.ai
              </a>
              . You also have the right to complain to the Information Commissioner's
              Office ({' '}
              <a href="https://ico.org.uk" className="lp-link" target="_blank" rel="noreferrer">
                ico.org.uk
              </a>
              ).
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">9. Cookies</h2>
            <p className="lp-section__body">
              We use cookies to keep you logged in, remember your progress and understand
              how the site is used. You can control cookies through your browser settings.
              A separate cookie notice is shown on first visit.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">10. Contact</h2>
            <p className="lp-section__body">
              Questions about this policy? Email{' '}
              <a href="mailto:amanda@PropertyTraining.ai" className="lp-link">
                amanda@PropertyTraining.ai
              </a>
              .
            </p>
          </section>

        </div>
      </main>

    </div>
  );
}